import React from "react";
import parse from "html-react-parser";
import Button from "../Button";
import Spacing from "../Spacing";
import Div from "../Div";

export default function SectionHeading({
  title,
  subtitle,
  btnLink,
  btnText,
  variant,
  children,
}) {
  return (
    <Div
      className={
        variant
          ? `_section_heading ${variant}`
          : `_section_heading _style12`
      }
    >
      <h2 className="_section_title">{parse(title)}</h2>
      <br/>
      <h3 className="_section_subtitle">{parse(subtitle)}</h3>
      {children}
      {btnText && (
        <>
          <Spacing lg="45" md="20" />
          <Button btnLink={btnLink} btnText={btnText} />
        </>
      )}
    </Div>
  );
}
